import React from 'react';

class OverlayFooter extends React.Component {
  render() {
    return <div className="overlay-footer">{this.props.children}</div>;
  }
}

export default OverlayFooter;
